import { Outlet } from 'react-router-dom';
import { CreateUserModal } from '@/components/CreateUserModal';
import { Navigation } from '@/components/HeaderNavigation';
import useSetInitialRetailer from '@/hooks/useSetInitialRetailer';
import { useAppSelector } from '@/store/hooks';

export default function FarmersLayout() {
  const { data: user, isRetrieved: userRetreived } = useAppSelector(
    (state) => state.user,
  );
  useSetInitialRetailer();

  if (userRetreived && !user) {
    return <CreateUserModal />;
  }

  return (
    <div className="flex flex-col min-h-100vh overflow-hidden text-primary-black container pt-15-0 md:pt-8-0">
      <Navigation />
      <Outlet />
    </div>
  );
}
